import React from "react";
import { useAuth } from "../context/AuthContext";
import { FolderOpen, Users, Eye } from "lucide-react";

const DashboardHome = () => {
	const { currentUser, isAdmin } = useAuth();

	const stats = [
		{
			icon: FolderOpen,
			label: "Available Projects",
			value: "12",
			color: "bg-blue-600",
		},
		{ icon: Eye, label: "Projects Viewed", value: "8", color: "bg-green-600" },
		...(isAdmin
			? [
					{
						icon: Users,
						label: "Total Users",
						value: "24",
						color: "bg-orange-600",
					},
			  ]
			: []),
	];

	return (
		<div className="space-y-6">
			<div>
				<h2 className="text-3xl font-bold text-white mb-2">
					Welcome back, {currentUser?.name || "User"}!
				</h2>
				<p className="text-gray-400">
					{isAdmin
						? "Manage your portfolio and users from here."
						: "View your assigned content and demos."}
				</p>
			</div>

			{/* Stats Grid */}
			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
				{stats.map((stat, index) => (
					<div
						key={index}
						className="bg-gray-800 border border-gray-700 rounded-lg p-6"
					>
						<div className="flex items-center justify-between">
							<div>
								<p className="text-gray-400 text-sm mb-1">{stat.label}</p>
								<p className="text-3xl font-bold text-white">{stat.value}</p>
							</div>
							<div className={`${stat.color} p-3 rounded-lg`}>
								<stat.icon className="w-6 h-6 text-white" />
							</div>
						</div>
					</div>
				))}
			</div>

			{/* Recent Activity */}
			<div className="bg-gray-800 border border-gray-700 rounded-lg p-6">
				<h3 className="text-xl font-semibold text-white mb-4">
					Recent Activity
				</h3>
				<div className="space-y-3">
					{[
						{
							action: "Viewed project",
							name: "E-commerce Platform",
							time: "2 hours ago",
						},
						{
							action: "Accessed demo",
							name: "Mobile App Design",
							time: "1 day ago",
						},
						{
							action: "Downloaded assets",
							name: "Brand Guidelines",
							time: "3 days ago",
						},
					].map((activity, index) => (
						<div
							key={index}
							className="flex items-center justify-between py-3 border-b border-gray-700 last:border-0"
						>
							<div>
								<p className="text-white font-medium">{activity.name}</p>
								<p className="text-sm text-gray-400">{activity.action}</p>
							</div>
							<span className="text-sm text-gray-500">{activity.time}</span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default DashboardHome;
